import styled from "styled-components";
import { colors } from "../../../common/ui/globalColors";

export const StyledPaymentsCard = styled.div`
    position: relative;

    .body-card {
        background: ${props => props.canceledPayment ? colors.additionalColors.coral : colors.semiTransparentColors.white};
        border: 1px solid ${colors.additionalColors.lightBlue};
        box-shadow: 0px 3px 34px ${colors.semiTransparentColors.darkGray};
        border-radius: 11px;
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
        padding: 16px 18px;
        display: grid;
        gap: 5px;
        grid-template-columns: repeat(9, 1fr);
        color: ${colors.semiTransparentColors.grayBlue};
        text-align: center;
        margin-left: 50px;
        align-items: center;
        font-size: 12px;
        line-height: 14px;
        height: 46px;

        .name {
            text-overflow: ellipsis; 
            white-space: nowrap; 
            overflow: hidden; 
            width: 100px;
        }
    }

    .payment-info {
        margin-left: 50px;
        padding: 7px 37px 0;
        display: grid;
        grid-template-columns: ${({ bllinkCharges }) => bllinkCharges ? 'repeat(8, 1fr)' : 'repeat(7, 1fr)'};
        gap: 20px;
        text-align: center;
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

        .info-list {
            display: flex;
            flex-direction: column;
            color: ${colors.semiTransparentColors.grayBlue};
            font-size: 12px;
            line-height: 22px;
            text-align: start;

            .highlited-info {
                font-weight: 700;
            }

            .more-details {
                line-height: 25px;
            }
        }
    }

    .tool {
        width: 32px;
        height: 32px;
        background-color: ${colors.additionalColors.lightGray};
        border-radius: 50px;
        cursor: pointer;
        position: absolute;
        left: 3px;
        top: 10px;
        display: flex;
        flex-direction: column;
        gap: 3px;
        align-items: center;
        justify-content: center;
        box-shadow: -2px 3px 7px 0 ${colors.semiTransparentColors.buttonShadowGray};

        .dot {
            background-color: var(--bllink-purple);
            width: 3px;
            height: 3px;
            border-radius: 50px;
        }

        :hover {
            background: linear-gradient(180deg, ${colors.additionalColors.brightBlue} 0%, ${colors.additionalColors.purple} 100%);
            color: ${colors.textColors.white};

            .dot {
                background-color: ${colors.textColors.white};
            }
        }
    }
`
